import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refreshMe = () =>
    api.get("/auth/me").then((r) => setUser(r.data)).catch(() => setUser(false));

  useEffect(() => {
    refreshMe();
  }, []);

  const handleAuth = (data) => {
    localStorage.setItem("fa_token", data.access_token);
    localStorage.setItem("fa_refresh", data.refresh_token);
    setUser(data.user);
    return data.user;
  };

  const login = async (email, password) => handleAuth((await api.post("/auth/login", { email, password })).data);
  const register = async (payload) => handleAuth((await api.post("/auth/register", payload)).data);
  const logout = async () => {
    await api.post("/auth/logout").catch(() => {});
    localStorage.removeItem("fa_token");
    localStorage.removeItem("fa_refresh");
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, login, register, logout, refreshMe }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
